export default (
  // state = window.location.host.indexOf("adesk") === -1
  //   ? "Crew Mama"
  //   : "ADesk | Film, Video, Production & Camera Crew Directory",
  state = "Crew Mama",
  action
) => {
  if (action.type === "PAGE_TITLE") {
    return action.payload
  } else {
    return state
  }
}
